var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuizClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 428.43 435.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        font-family: UniversCondensed-Medium, 'Univers Condensed';\n        font-size: 15.48px;\n        font-weight: 500;\n      }\n\n      .cls-4 {\n        fill: #d8d8d8;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-6 {\n        fill: #a6a6a6;\n      }\n\n      .cls-7 {\n        fill: #323c3f;\n      }\n\n      .cls-8 {\n        fill: #4e4e4e;\n      }\n\n      .cls-9, .cls-10 {\n        stroke-width: .38px;\n      }\n\n      .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke: #1a2e35;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-9, .cls-12 {\n        fill: #902df9;\n      }\n\n      .cls-10 {\n        fill: #1a2e35;\n      }\n\n      .cls-11 {\n        fill: #fedb4a;\n      }\n\n      .cls-11, .cls-12 {\n        stroke-width: .78px;\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-11);\n        filter: url(#drop-shadow-1);\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-15 {\n        fill: #626262;\n      }\n\n      .cls-16 {\n        fill: #767676;\n      }\n\n      .cls-17 {\n        fill: #898989;\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-19 {\n        fill: #ebebeb;\n      }\n\n      .cls-20 {\n        letter-spacing: .03em;\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-22 {\n        fill: #b1b1b1;\n      }\n\n      .cls-23 {\n        letter-spacing: .02em;\n      }\n\n      .cls-23, .cls-24 {\n        font-family: UniversCondensed-Bold, 'Univers Condensed';\n        font-size: 26.26px;\n        font-weight: 700;\n      }\n\n      .cls-25 {\n        opacity: .62;\n      }\n\n      .cls-24 {\n        letter-spacing: .03em;\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-27 {\n        letter-spacing: .03em;\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-30 {\n        isolation: isolate;\n        opacity: .1;\n      }\n\n      .cls-31 {\n        letter-spacing: .03em;\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-33 {\n        fill: #c4c4c4;\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-35 {\n        fill: #263238;\n      }\n\n      .cls-36 {\n        fill: #442491;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 6.95,
    y1: 201.42,
    x2: 421.48,
    y2: 201.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c927f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c927f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 430.08,
    x2: 428.43,
    y2: 430.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 160.01,
    y1: 371.95,
    x2: 213.97,
    y2: 371.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 214.46,
    y1: 371.95,
    x2: 268.42,
    y2: 371.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 23.9,
    y1: 353.19,
    x2: 31.93,
    y2: 353.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 23.9,
    y1: 312.88,
    x2: 173.61,
    y2: 312.88,
    gradientTransform: "translate(411.63 214.13) rotate(90)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 23.9,
    y1: 284.57,
    x2: 214.46,
    y2: 284.57,
    gradientTransform: "translate(403.75 165.39) rotate(90)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 396.95,
    y1: 353.19,
    x2: 404.98,
    y2: 353.19,
    gradientTransform: "translate(801.93 706.38) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 255.27,
    y1: 312.88,
    x2: 404.98,
    y2: 312.88,
    gradientTransform: "translate(643 -17.24) rotate(90)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 214.42,
    y1: 284.57,
    x2: 404.98,
    y2: 284.57,
    gradientTransform: "translate(594.27 -25.13) rotate(90)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 409.14,
    y1: 162.47,
    x2: 366.23,
    y2: 153.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m348.1,80.77l-16.02-16.02-25.06,25.06.02.02s-.08.04-.11.07c-.95.95,1.86,5.3,6.29,9.73,4.42,4.42,8.78,7.24,9.73,6.29.03-.03.05-.07.07-.11l.02.02,25.06-25.06Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "343.56 145.12 328.97 145.12 332.15 88.35 340.38 88.35 343.56 145.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "336.26 145.12 343.56 145.12 340.38 88.35 336.26 88.35 336.26 145.12"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m355.42,69.5c2.33,8.99-3.08,18.16-12.07,20.49-8.99,2.32-18.16-3.08-20.48-12.07-2.33-8.99,3.07-18.16,12.06-20.48,8.99-2.33,18.16,3.08,20.48,12.06Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m408.08,95.15l-46.83-46.04L316.96.62s-31.66,20.19,18.8,73.05c50.97,52.37,72.31,21.48,72.31,21.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m340.67,69.15c-36.76-38.51-29.94-59.68-23.53-68.33l-.18-.2s-31.66,20.19,18.8,73.05c49.6,50.97,71.14,23.08,72.27,21.54-8.93,6.08-30.32,11.99-67.36-26.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m408.08,95.15c-3.18,3.06-16.74-5.53-33.6-20.51-.6-.54-1.2-1.07-1.82-1.63-5.76-5.2-11.86-11.1-18.04-17.51-6.56-6.81-12.55-13.5-17.75-19.76-.51-.6-1-1.21-1.49-1.8-13.83-16.92-21.54-30.31-18.42-33.32,3.64-3.51,20.92,8.29,41.17,27.47.6.57,1.21,1.15,1.81,1.73,3.44,3.3,6.94,6.8,10.47,10.46,2.65,2.76,5.22,5.49,7.67,8.19.59.65,1.17,1.3,1.75,1.94,19.79,22.06,32.03,41.1,28.23,44.75Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m390.81,22.29c0,3.22-2.61,5.84-5.84,5.84s-5.84-2.61-5.84-5.84,2.61-5.84,5.84-5.84,5.84,2.61,5.84,5.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m386.38,20.82l-6.54,29.57-5.36,24.24c-.6-.54-1.2-1.07-1.82-1.63l5.43-24.55,5.47-24.72-23.61,6.07-23.07,5.92c-.51-.6-1-1.21-1.49-1.8l22.75-5.85,28.25-7.26Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m119.19,100.97l10.74-10.73,16.79,16.79h-.01s.05.04.08.06c.64.64-1.25,3.56-4.21,6.52-2.96,2.96-5.88,4.85-6.52,4.21-.02-.02-.03-.05-.05-.08v.02s-16.81-16.79-16.81-16.79Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "122.23 144.1 132.01 144.1 129.88 106.05 124.36 106.05 122.23 144.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "127.12 144.1 122.23 144.1 124.36 106.05 127.12 106.05 127.12 144.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m114.28,93.41c-1.56,6.02,2.06,12.17,8.09,13.73,6.02,1.56,12.17-2.06,13.73-8.09,1.56-6.02-2.06-12.17-8.09-13.73-6.02-1.56-12.17,2.06-13.73,8.09Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m78.99,110.61l31.39-30.86,29.68-32.5s21.22,13.53-12.6,48.97c-34.16,35.1-48.47,14.4-48.47,14.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m124.17,93.18c24.64-25.81,20.07-40,15.77-45.8l.12-.13s21.22,13.53-12.6,48.97c-33.25,34.16-47.69,15.47-48.44,14.44,5.98,4.07,20.32,8.04,45.15-17.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m78.99,110.61c2.13,2.05,11.22-3.7,22.52-13.74.4-.36.81-.72,1.22-1.09,3.86-3.48,7.95-7.44,12.09-11.74,4.39-4.56,8.41-9.05,11.89-13.25.34-.41.67-.81,1-1.21,9.27-11.34,14.44-20.32,12.35-22.33-2.44-2.35-14.02,5.55-27.6,18.41-.4.38-.81.77-1.21,1.16-2.3,2.21-4.65,4.55-7.02,7.01-1.78,1.85-3.5,3.68-5.14,5.49-.4.43-.79.87-1.17,1.3-13.26,14.78-21.47,27.55-18.92,30Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m90.56,61.77c0,2.16,1.75,3.91,3.91,3.91s3.91-1.75,3.91-3.91c0-2.16-1.75-3.91-3.91-3.91s-3.91,1.75-3.91,3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m93.53,60.79l4.38,19.82,3.59,16.25c.4-.36.81-.72,1.22-1.09l-3.64-16.46-3.66-16.57,15.83,4.07,15.46,3.97c.34-.41.67-.81,1-1.21l-15.25-3.92-18.93-4.86Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 6.95,
    y: 149.49,
    width: 414.53,
    height: 103.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.95,
    y: 150.33,
    width: 414.53,
    height: 31.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.95,
    y: 253.34,
    width: 414.53,
    height: 180.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 226.37,
    y: 175.32,
    width: 19.92,
    height: 8.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 411.51,
    y: 175.33,
    width: 9.97,
    height: 8.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 289.77,
    y: 231.81,
    width: 19.92,
    height: 8.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 153.7,
    y: 238.77,
    width: 19.92,
    height: 8.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 15,
    y: 238.77,
    width: 19.92,
    height: 8.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 6.95,
    y: 228.23,
    width: 16.21,
    height: 8.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 365.83,
    y: 231.81,
    width: 19.92,
    height: 8.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 278.66,
    y: 221.17,
    width: 19.92,
    height: 8.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 253.34,
    width: 428.43,
    height: 8.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 173.54,
    width: 428.43,
    height: 8.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 425.82,
    width: 428.43,
    height: 8.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 0,
    y: 253.34,
    width: 428.43,
    height: 8.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 0,
    y: 173.54,
    width: 428.43,
    height: 8.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 144.84,
    width: 428.43,
    height: 8.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    y: 144.84,
    width: 428.43,
    height: 8.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 425.82,
    width: 428.43,
    height: 8.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    y: 425.82,
    width: 428.43,
    height: 8.51
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 160.01,
    y: 308.87,
    width: 53.96,
    height: 126.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 168.04,
    y: 317.08,
    width: 37.91,
    height: 85.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 208.36,
    y: 374.32,
    width: 2.62,
    height: 14.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 214.46,
    y: 308.87,
    width: 53.96,
    height: 126.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 222.48,
    y: 317.08,
    width: 37.91,
    height: 85.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 217.46,
    y: 374.32,
    width: 2.62,
    height: 14.19
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 31.93,
    y: 317.14,
    width: 128.08,
    height: 108.68
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 23.9,
    y: 280.56,
    width: 8.03,
    height: 145.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 94.74,
    y: 238.03,
    width: 8.03,
    height: 149.71,
    transform: "translate(-214.13 411.63) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 115.17,
    y: 189.29,
    width: 8.03,
    height: 190.56,
    transform: "translate(-165.39 403.75) rotate(-90)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 396.95,
    y: 280.56,
    width: 8.03,
    height: 145.27,
    transform: "translate(801.93 706.38) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 326.11,
    y: 238.03,
    width: 8.03,
    height: 149.71,
    transform: "translate(17.24 643) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 305.68,
    y: 189.29,
    width: 8.03,
    height: 190.56,
    transform: "translate(25.13 594.27) rotate(-90)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 268.71,
    y: 316.89,
    width: 128.6,
    height: 108.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 31.93,
    y: 288.58,
    width: 365.02,
    height: 20.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.79,
    y: 199.64,
    width: 34.58,
    height: 34.58
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(37.21 226.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.89,
    y: 199.64,
    width: 34.58,
    height: 34.58
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-24",
    transform: "translate(86.07 226.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "V")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 124.99,
    y: 199.64,
    width: 34.58,
    height: 34.58
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(134.93 226.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 174.09,
    y: 199.64,
    width: 34.58,
    height: 34.58
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(184.51 226.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 223.19,
    y: 199.64,
    width: 34.58,
    height: 34.58
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(232.89 226.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "U")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 272.29,
    y: 199.64,
    width: 34.58,
    height: 34.58
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(281.99 226.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 321.39,
    y: 199.64,
    width: 34.58,
    height: 34.58
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(334.96 226.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 369.15,
    y: 199.64,
    width: 34.58,
    height: 34.58
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(378.85 226.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m20.93,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m31.65,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m42.36,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m53.08,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m63.8,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m74.52,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m85.24,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m95.95,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m106.67,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m117.39,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m128.11,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m138.83,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m149.54,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m160.26,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m170.98,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m181.7,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m192.41,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m203.13,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m213.85,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m224.57,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m235.29,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m246,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m256.72,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m267.44,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m278.16,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m288.88,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m299.59,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m310.31,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m321.03,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m331.75,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m342.46,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m353.18,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m363.9,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m374.62,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m385.34,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m396.05,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m406.77,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m417.49,271.05c0,2.26-1.83,4.1-4.1,4.1s-4.1-1.83-4.1-4.1,1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m16.83,275.15c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m16.83,285.87c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m16.83,296.59c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m16.83,307.3c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m16.83,318.02c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m16.83,328.74c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m16.83,339.46c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m16.83,350.17c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m16.83,360.89c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m16.83,371.61c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m16.83,382.33c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m16.83,393.05c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m16.83,403.76c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m16.83,414.48c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m16.83,425.2c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m413.39,286.59c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m413.39,297.31c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m413.39,308.03c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m413.39,318.74c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m413.39,329.46c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m413.39,340.18c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m413.39,350.9c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m413.39,361.61c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m413.39,372.33c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m413.39,383.05c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m413.39,393.77c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m413.39,404.49c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m413.39,415.2c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m413.39,425.92c-2.26,0-4.1-1.83-4.1-4.1s1.83-4.1,4.1-4.1,4.1,1.83,4.1,4.1-1.83,4.1-4.1,4.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m409.29,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m398.58,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m387.86,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m377.14,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1c0-2.26-1.83-4.1-4.1-4.1s-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m366.42,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m355.7,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m344.99,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m334.27,164.64c0,2.26,1.83,4.1,4.1,4.1,2.26,0,4.1-1.83,4.1-4.1s-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m323.55,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m312.83,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m302.11,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1c0-2.26-1.83-4.1-4.1-4.1s-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m291.4,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m280.68,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m269.96,164.64c0,2.26,1.83,4.1,4.1,4.1,2.26,0,4.1-1.83,4.1-4.1s-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m259.24,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m248.53,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m237.81,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1c0-2.26-1.83-4.1-4.1-4.1s-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m227.09,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m216.37,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m205.65,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m194.94,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m184.22,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m173.5,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1c0-2.26-1.83-4.1-4.1-4.1s-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m162.78,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1c-2.26,0-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m152.07,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m141.35,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1c0-2.26-1.83-4.1-4.1-4.1s-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m130.63,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1c0-2.26-1.83-4.1-4.1-4.1s-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m119.91,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m109.19,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1c0-2.26-1.83-4.1-4.1-4.1s-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m98.48,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1c0-2.26-1.83-4.1-4.1-4.1s-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m87.76,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1c0-2.26-1.83-4.1-4.1-4.1s-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m77.04,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m66.32,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m55.6,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1c0-2.26-1.83-4.1-4.1-4.1s-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m44.89,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m34.17,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1c0-2.26-1.83-4.1-4.1-4.1s-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m23.45,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m12.73,164.64c0,2.26,1.83,4.1,4.1,4.1s4.1-1.83,4.1-4.1-1.83-4.1-4.1-4.1-4.1,1.83-4.1,4.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "205.95 317.08 205.95 324.56 168.04 362.48 168.04 344.52 195.45 317.08 205.95 317.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "205.95 356.26 205.95 374.21 178.07 402.15 168.04 402.15 168.04 394.22 205.95 356.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "205.95 348.38 205.95 352.17 168.04 390.15 168.04 386.34 205.95 348.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "191.65 317.08 168.04 340.7 168.04 333.26 184.22 317.08 191.65 317.08"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "260.4 317.08 260.4 324.56 222.48 362.48 222.48 344.52 249.9 317.08 260.4 317.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "260.4 356.26 260.4 374.21 232.52 402.15 222.48 402.15 222.48 394.22 260.4 356.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "260.4 348.38 260.4 352.17 222.48 390.15 222.48 386.34 260.4 348.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "246.09 317.08 222.48 340.7 222.48 333.26 238.66 317.08 246.09 317.08"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 222.48,
    y: 378.4,
    width: 37.91,
    height: 6.04
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-19",
    points: "168.04 384.43 168.04 378.4 205.95 378.4 205.95 384.43"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "31.93 348.1 31.93 375.09 89.88 317.14 62.88 317.14 31.93 348.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "133.2 317.14 119.87 317.14 31.93 405.09 31.93 418.42 133.2 317.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "160.01 417.32 160.01 403.99 138.18 425.82 151.51 425.82 160.01 417.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "160.01 383.71 160.01 321.93 56.12 425.82 117.9 425.82 160.01 383.71"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "268.42 348.1 268.42 375.09 326.37 317.14 299.38 317.14 268.42 348.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "369.69 317.14 356.36 317.14 268.42 405.09 268.42 418.42 369.69 317.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "396.51 417.32 396.51 403.99 374.68 425.82 388.01 425.82 396.51 417.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "396.51 383.71 396.51 321.93 292.61 425.82 354.4 425.82 396.51 383.71"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "71.04 308.87 98.04 308.87 118.32 288.58 91.33 288.58 71.04 308.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "161.65 288.58 148.32 288.58 128.03 308.87 141.36 308.87 161.65 288.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "288.64 288.58 275.31 288.58 255.02 308.87 268.35 308.87 288.64 288.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "255.03 288.58 193.24 288.58 172.96 308.87 234.74 308.87 255.03 288.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "354.97 288.58 327.98 288.58 307.69 308.87 334.68 308.87 354.97 288.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "396.51 290.37 396.51 288.58 384.96 288.58 364.68 308.87 378.01 308.87 396.51 290.37"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m75.04,412.27c-.87-.13-1.95-.43-3.25-.9-1.3-.47-2.64-1.08-4.01-1.84-1.37-.75-2.58-1.58-3.63-2.48-.13.07-.26.13-.4.17-.14.04-.3.09-.47.14-3.16.91-5.83,1.08-7.99.5-2.16-.58-3.95-1.8-5.35-3.65-1.4-1.86-2.52-4.23-3.35-7.11l-4.53-15.7c-.84-2.92-1.16-5.52-.95-7.81.21-2.28,1.07-4.24,2.6-5.86,1.53-1.63,3.87-2.9,7.04-3.81,3.2-.92,5.89-1.11,8.06-.55,2.18.56,3.96,1.75,5.35,3.57,1.39,1.82,2.51,4.19,3.35,7.11l4.53,15.7c.57,1.98.91,3.83,1,5.53.1,1.71-.09,3.27-.57,4.68-.48,1.42-1.29,2.67-2.45,3.76.59.36,1.2.7,1.82,1.03.62.33,1.23.62,1.84.88.6.26,1.18.44,1.74.54l-.39,6.1Zm-13.67-11.54c.97-.28,1.62-.73,1.93-1.35.31-.62.43-1.33.34-2.13-.08-.8-.24-1.61-.47-2.41l-5.87-20.34c-.24-.83-.54-1.61-.89-2.31-.36-.71-.83-1.24-1.42-1.6-.59-.36-1.38-.39-2.35-.11-.97.28-1.61.73-1.9,1.34-.29.61-.39,1.31-.3,2.09.09.78.26,1.59.5,2.43l5.87,20.34c.23.8.52,1.57.86,2.29.34.73.8,1.28,1.38,1.64.57.36,1.35.4,2.32.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m93.95,398.5c-3.23.93-5.92,1.13-8.05.6s-3.86-1.71-5.17-3.54c-1.32-1.82-2.4-4.21-3.26-7.17l-8.42-29.16,9.23-2.66,8.82,30.57c.25.87.57,1.72.96,2.55.39.83.9,1.45,1.53,1.88.63.42,1.43.49,2.41.21,1.01-.29,1.66-.78,1.95-1.47.29-.69.37-1.48.24-2.39-.13-.9-.32-1.79-.57-2.66l-8.82-30.57,9.28-2.68,8.42,29.16c.85,2.96,1.2,5.56,1.04,7.81-.16,2.25-.99,4.17-2.49,5.75-1.5,1.58-3.87,2.84-7.1,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m112.28,392.53l-12.2-42.25,9.34-2.69,12.2,42.25-9.34,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m126.31,388.48l-1.63-5.63,1.58-33.29-9.86,2.85-1.82-6.31,19.04-5.5,1.52,5.27-1.63,33.7,10.59-3.06,1.82,6.31-19.61,5.66Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m76.28,410.21c-.87-.13-1.95-.43-3.25-.9-1.3-.47-2.64-1.08-4.01-1.84-1.37-.75-2.58-1.58-3.63-2.48-.13.07-.26.13-.4.17-.14.04-.3.09-.47.14-3.16.91-5.83,1.08-7.99.5-2.16-.58-3.95-1.8-5.35-3.65-1.4-1.86-2.52-4.23-3.35-7.11l-4.53-15.7c-.84-2.92-1.16-5.52-.95-7.81.21-2.28,1.07-4.24,2.6-5.86,1.53-1.63,3.87-2.9,7.04-3.81,3.2-.92,5.89-1.11,8.06-.55,2.18.56,3.96,1.75,5.35,3.57,1.39,1.82,2.51,4.19,3.35,7.11l4.53,15.7c.57,1.98.91,3.83,1,5.53.1,1.71-.09,3.27-.57,4.68-.48,1.42-1.29,2.67-2.45,3.76.59.36,1.2.7,1.82,1.03.62.33,1.23.62,1.84.88.6.26,1.18.44,1.74.54l-.39,6.1Zm-13.67-11.54c.97-.28,1.62-.73,1.93-1.35.31-.62.43-1.33.34-2.13-.08-.8-.24-1.61-.47-2.41l-5.87-20.34c-.24-.83-.54-1.61-.89-2.31-.36-.71-.83-1.24-1.42-1.6-.59-.36-1.38-.39-2.35-.11-.97.28-1.61.73-1.9,1.34-.29.61-.39,1.31-.3,2.09.09.78.26,1.59.5,2.43l5.87,20.34c.23.8.52,1.57.86,2.29.34.73.8,1.28,1.38,1.64.57.36,1.35.4,2.32.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m95.19,396.45c-3.23.93-5.92,1.13-8.05.6-2.13-.53-3.86-1.71-5.17-3.54-1.32-1.82-2.4-4.21-3.26-7.17l-8.42-29.16,9.23-2.66,8.82,30.57c.25.87.57,1.72.96,2.55.39.83.9,1.45,1.53,1.88.63.42,1.43.49,2.41.21,1.01-.29,1.66-.78,1.95-1.47.29-.69.37-1.48.24-2.39-.13-.9-.32-1.79-.57-2.66l-8.82-30.57,9.28-2.68,8.42,29.16c.85,2.96,1.2,5.56,1.04,7.81-.16,2.25-.99,4.17-2.49,5.75-1.5,1.58-3.87,2.84-7.1,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m113.52,390.48l-12.2-42.25,9.34-2.69,12.2,42.25-9.34,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m127.55,386.43l-1.63-5.63,1.58-33.29-9.86,2.85-1.82-6.31,19.04-5.5,1.52,5.27-1.63,33.7,10.59-3.06,1.82,6.31-19.61,5.66Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 54.49,
    y: 333.73,
    width: 40.09,
    height: 17.88,
    transform: "translate(-91.67 33.87) rotate(-16.02)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(62.93 351.6) rotate(-16.02)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 0,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 7.05,
    y: 0
  }, "IN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 19.61,
    y: 0
  }, "D"))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(37.21 226.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    className: "cls-24",
    transform: "translate(86.07 226.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "V")), /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(134.93 226.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(184.51 226.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(232.89 226.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "U")), /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(281.99 226.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D")), /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(334.96 226.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(378.85 226.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(62.93 351.6) rotate(-16.02)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 0,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 7.05,
    y: 0
  }, "IN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 19.61,
    y: 0
  }, "D"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m78.99,110.61h0s.01.02.03.05c0,0,0,0,0,0,.01.02.04.05.06.08,0,0,0,0,0,0,.02.03.04.06.07.09,0,0,0,0,0,0,.03.03.05.07.09.11,0,0,0,.01.01.02.03.04.06.08.1.12,0,0,.01.01.02.02.04.04.08.09.12.14,0,0,.02.02.03.03.04.05.08.09.13.15.01.01.02.02.03.04.05.05.1.1.15.16.01.01.02.03.04.04.05.05.11.11.16.17.01.01.03.03.04.04.06.06.12.12.18.18.02.01.03.03.05.04.06.06.13.12.2.18.02.02.04.03.05.05.07.06.14.13.22.19.02.02.04.03.05.05.08.07.15.13.24.2.02.02.04.03.06.05.08.07.17.14.26.21.02.02.04.03.06.05.09.07.18.14.28.21.02.02.04.03.06.05.1.07.2.14.3.21.02.02.04.03.07.05.11.07.21.15.33.22.02.01.04.02.06.04.11.08.23.15.35.23.02.01.04.02.05.03.12.08.25.15.38.22.02.01.04.02.05.03.13.08.27.15.41.23.01,0,.02.01.04.02.15.08.3.15.45.23,0,0,.02.01.03.02,1.64.81,3.67,1.48,6.11,1.73.03,0,.05,0,.08,0,.22.02.43.04.66.05.05,0,.09,0,.14,0,.21.01.41.02.63.03.06,0,.12,0,.18,0,.2,0,.4,0,.6,0,.07,0,.15,0,.22,0,.19,0,.39,0,.59-.02.08,0,.17-.01.26-.02.19-.01.38-.02.58-.04.09,0,.19-.02.29-.03.19-.02.38-.04.57-.06.1-.01.21-.03.31-.04.19-.03.38-.05.57-.08.11-.02.23-.04.34-.06.19-.03.38-.07.57-.1.12-.02.24-.05.36-.07.19-.04.38-.08.57-.13.13-.03.25-.06.38-.09.19-.05.38-.1.58-.15.13-.04.27-.07.4-.11.19-.05.39-.11.59-.17.14-.04.28-.09.42-.13.2-.06.39-.13.59-.19.15-.05.29-.1.44-.15.2-.07.4-.14.6-.22.15-.06.31-.12.46-.18.2-.08.4-.16.6-.24.16-.07.32-.13.48-.2.2-.09.41-.17.61-.27.16-.07.33-.15.49-.22.21-.09.41-.19.62-.29.17-.08.34-.16.51-.25.21-.1.42-.21.63-.32.18-.09.35-.18.53-.28.21-.11.42-.23.63-.34.18-.1.37-.2.56-.31.21-.12.42-.24.64-.37.19-.11.38-.22.57-.34.21-.13.43-.26.65-.4.2-.12.39-.24.59-.37.22-.14.44-.28.66-.42.2-.13.4-.26.6-.4.22-.15.45-.3.68-.46.2-.14.41-.28.62-.42.23-.16.46-.32.69-.49.21-.15.42-.3.63-.46.23-.17.46-.34.7-.52.22-.16.43-.32.65-.49.23-.18.47-.37.71-.55.22-.17.44-.34.66-.52.24-.19.49-.4.73-.6.08-.06.15-.12.23-.19,1.23,1.01,2.68,1.78,4.32,2.21.64.17,1.28.26,1.91.31l-2.06,36.65h9.78l-1.8-32.11,5.77,5.77v-.02s.04.06.06.08c.64.64,3.56-1.25,6.52-4.21,2.96-2.96,4.85-5.88,4.21-6.52-.02-.02-.05-.03-.08-.05h.01s-10.27-10.29-10.27-10.29c.14-2.86-.84-5.61-2.62-7.74,24.54-30.08,6.23-41.77,6.23-41.77h0s0,0,0,0c-2.44-2.35-14.02,5.55-27.6,18.41l-14.1-3.62c0-.09.03-.17.03-.26,0-2.16-1.75-3.91-3.91-3.91s-3.91,1.75-3.91,3.91,1.75,3.91,3.91,3.91c.05,0,.09-.01.13-.01l3.3,14.94c-13.26,14.78-21.47,27.55-18.93,30Zm17.02-45.23c.89-.38,1.6-1.08,2.01-1.96l13.23,3.4c-2.3,2.21-4.65,4.55-7.02,7.01-1.78,1.85-3.5,3.68-5.14,5.49l-3.08-13.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m428.43,153.34v-8.51h-84.88l-3.05-54.39c.95-.08,1.9-.22,2.86-.47,2.45-.63,4.62-1.79,6.45-3.3.12.1.23.19.35.28.36.3.73.6,1.09.88.33.26.66.52.99.78.36.28.71.56,1.06.83.32.25.64.49.96.73.35.26.7.52,1.04.78.32.23.63.46.94.68.34.25.68.49,1.02.73.31.22.62.42.92.63.34.23.67.46,1,.68.3.2.6.39.9.59.33.21.66.43.99.64.29.18.58.36.87.54.33.2.65.4.98.59.28.17.57.33.85.5.32.19.64.37.96.55.27.15.55.3.82.45.32.17.64.35.95.51.27.14.53.28.79.41.31.16.62.32.93.47.26.13.52.25.77.38.31.15.61.29.92.43.25.11.5.23.74.34.31.14.61.27.91.4.24.1.48.2.71.3.3.12.6.24.9.36.23.09.46.18.68.26.3.11.6.22.89.32.22.08.44.15.66.23.3.1.59.2.88.29.21.07.42.13.63.2.29.09.58.17.87.25.2.06.4.11.6.17.29.08.58.15.87.22.19.05.38.09.57.14.29.07.58.13.87.19.18.04.35.07.53.11.29.06.58.11.86.16.17.03.33.06.5.08.29.05.57.09.86.12.15.02.31.04.46.06.29.04.58.06.86.09.14.01.28.03.42.04.29.02.58.04.87.06.13,0,.25.02.38.02.3.01.59.02.88.03.11,0,.22,0,.33,0,.3,0,.6,0,.89,0,.09,0,.19,0,.28,0,.31,0,.62-.02.92-.04.07,0,.14,0,.21-.01.33-.02.66-.05.98-.08.04,0,.08,0,.12,0,.36-.04.71-.08,1.06-.13,0,0,0,0,0,0,2.83-.39,5.26-1.17,7.31-2.1,0,0,0,0,0,0,.25-.12.5-.23.74-.35.01,0,.02-.01.04-.02.23-.11.45-.23.67-.35.02-.01.04-.02.07-.04.21-.11.41-.22.61-.34.03-.02.06-.03.08-.05.19-.11.38-.22.56-.33.03-.02.06-.04.1-.06.17-.11.34-.22.51-.33.03-.02.07-.04.1-.07.16-.11.32-.22.48-.32.03-.02.06-.04.09-.07.15-.11.3-.21.45-.32.03-.02.06-.05.09-.07.14-.11.28-.21.41-.31.03-.03.06-.05.1-.08.13-.1.25-.2.38-.3.03-.03.06-.05.09-.08.12-.1.24-.2.35-.29.03-.03.06-.05.09-.08.11-.1.22-.19.32-.29.03-.02.05-.05.08-.07.1-.09.2-.19.3-.28.02-.02.05-.04.07-.07.09-.09.18-.18.27-.26.02-.02.04-.04.06-.06.09-.09.17-.17.24-.25.02-.02.04-.04.06-.06.08-.08.15-.16.22-.23.02-.02.03-.04.05-.05.07-.07.13-.15.19-.21.01-.02.03-.03.04-.05.06-.07.12-.13.17-.2.01-.01.02-.02.03-.04.05-.06.1-.12.15-.18,0,0,.02-.02.02-.03.05-.06.09-.11.12-.15,0,0,.01-.01.02-.02.04-.05.07-.09.1-.13,0,0,0,0,0,0,.04-.05.07-.09.09-.12t0,0s.05-.07.05-.07h0c3.79-3.66-8.45-22.7-28.24-44.75l4.93-22.28c.07,0,.13.01.2.01,3.23,0,5.84-2.61,5.84-5.84s-2.61-5.84-5.84-5.84-5.84,2.61-5.84,5.84c0,.13.01.27.02.4l-21.02,5.4c-20.25-19.18-37.54-30.97-41.17-27.47h0s0,0,0,0c0,0-27.32,17.44,9.3,62.32-2.65,3.17-4.11,7.27-3.9,11.55l-15.33,15.33.02.02s-.08.04-.11.07c-.95.95,1.86,5.31,6.29,9.73,4.42,4.42,8.78,7.24,9.73,6.29.03-.03.05-.07.07-.11l.02.02,8.61-8.61-2.67,47.62H0v8.51h6.95v20.2H0v8.5h6.95v71.29H0v8.52h6.95v163.96H0v8.51h6.95s153.06,0,153.06,0v.7h53.96v-.7h.48v.7h53.96v-.7h153.06s6.95,0,6.95,0v-8.51h-6.95v-163.96h6.95v-8.52h-6.95v-71.29h6.95v-8.5h-6.95v-20.2h6.95Zm-48.75-128.6c.61,1.31,1.68,2.36,3.01,2.92l-4.6,20.8c-2.45-2.7-5.02-5.43-7.67-8.19-3.53-3.66-7.04-7.16-10.47-10.46l19.73-5.07Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m406.98,151.23l.4-2.58c.1-.71.16-1.41.19-2.11l.05-.49h-.05c.11-9.03-6.37-16.87-15.49-18.28-9.11-1.41-17.66,4.1-20.27,12.74h-.04s-.1.47-.1.47c-.2.68-.36,1.37-.46,2.08l-.4,2.58c-2.86-.44-5.53,1.53-5.97,4.37l-4.39,28.43c-.44,2.84,1.52,5.52,4.37,5.96l36.18,5.59c2.86.45,5.52-1.53,5.96-4.36l4.39-28.43c.44-2.85-1.52-5.52-4.36-5.97Zm-15.08,16.78c-.3,1.21-1.51,2.62-4.01,3.6-.27.11-.46.38-.45.68.17,2.73.26,4.6-.09,7.3-.05.37-.41.63-.78.58l-5.41-.84c-.38-.06-.63-.42-.58-.78.47-2.69,1.07-4.47,2.04-7.04.09-.26.03-.56-.18-.75-1.88-1.73-2.51-3.35-2.35-4.56.94-7.17,13.5-5.06,11.81,1.82Zm7.72-20.56l-.4,2.58-20.67-3.19.4-2.58c.1-.72.32-1.41.58-2.06.35-.93.83-1.77,1.39-2.54.18-.23.33-.46.53-.68.19-.22.4-.42.62-.64.26-.24.51-.48.8-.69.19-.16.4-.29.61-.43.33-.24.68-.45,1.05-.64.2-.09.4-.2.6-.29.4-.18.82-.31,1.23-.44.2-.05.39-.13.59-.18.45-.09.91-.15,1.38-.2.19-.02.38-.05.56-.06.66-.03,1.34,0,2.01.1.71.1,1.4.29,2.05.53,3.25,1.2,5.67,3.97,6.51,7.27.16.65.26,1.32.3,2.01.02.69-.01,1.41-.13,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m391.9,168.01c-.3,1.21-1.51,2.62-4.01,3.6-.27.11-.46.38-.45.68.17,2.73.26,4.6-.09,7.3-.05.37-.41.63-.78.58l-5.41-.84c-.38-.06-.63-.42-.58-.78.47-2.69,1.07-4.47,2.04-7.04.09-.26.03-.56-.18-.75-1.88-1.73-2.51-3.35-2.35-4.56.94-7.17,13.5-5.06,11.81,1.82Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizClosed);
export default __webpack_public_path__ + "static/media/quiz-closed.965c3662d0ff69016331fcfd8936147a.svg";
export { ForwardRef as ReactComponent };